import React from 'react';
import CoreLink from '../../components/core_link';
import Breadcrumbs from '../../components/breadcrumbs';

export interface BreadcrumbData {
  type: string;
  linkText: string;
  path: string;
}
export interface IProps {
  breadcrumbs: Array<BreadcrumbData>;
}

function getSortedBreadcrumbs(breadcrumbs: Array<BreadcrumbData>) {
  const breadcrumbTypeOrder = [
    'brand',
    'productType',
    'modelFamily',
    'subFamily',
    'series',
    'artist',
  ];
  return breadcrumbs.sort(
    (a, b) =>
      breadcrumbTypeOrder.indexOf(a.type) - breadcrumbTypeOrder.indexOf(b.type),
  );
}

function Breadcrumb(props: { breadcrumb: BreadcrumbData, idx: number }) {
  return (
    <>
      {!props.breadcrumb.path && <span itemProp="name">{props.breadcrumb.linkText}</span>}
      {props.breadcrumb.path &&
        <CoreLink to={props.breadcrumb.path}>
          <span itemProp="name">{props.breadcrumb.linkText}</span>
        </CoreLink>}
      <meta itemProp="position" content={`${props.idx + 1}`} />
    </>
  );
}

export default function BreadcrumbNavigation(props: IProps) {
  const { breadcrumbs } = props;
  if (!breadcrumbs.length) return null;

  return (
    <div className="cms-heading__breadcrumbs">
      <Breadcrumbs>
        {getSortedBreadcrumbs(breadcrumbs).map(
          (b, idx) =>
            !!b.linkText &&
            <Breadcrumb breadcrumb={b} idx={idx} key={b.type} />,
        )}
      </Breadcrumbs>
    </div>
  );
}
